import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    itemText: {
      textTransform: 'uppercase',
    },
  }),
);

export default useStyles;
